<template>
	<div class="usermana">
		<!-- 表头 -->
		<div class="button-group">
			<!-- 左侧按钮组 -->
			<div class="left-buttons">
				<el-button type="primary" @click="createDialogVisible = true">上传</el-button>
				<el-button type="success" @click="fetchResourceList">刷新</el-button>
				<el-button type="danger" :disabled="batchRemoveDisabled" @click="batchRemoveConfirm">删除选中</el-button>
			</div>

			<!-- 中间显示courseName -->
			<div class="course-name">
				{{ courseName }}
			</div>

			<!-- 右侧搜索框 -->
			<div class="search">
				<el-select v-model="filter.fileType" placeholder="请选择文件类型" size="large" style="width: 200px;"
					@change="fetchResourceList" clearable>
					<el-option label="doc" value="docx"></el-option>
					<el-option label="ppt" value="pptx"></el-option>
					<el-option label="mp4" value="mp4"></el-option>
					<el-option label="pdf" value="pdf"></el-option>
					<el-option label="其他" value="other"></el-option>
				</el-select>
			</div>
		</div>


		<!-- 表单 -->
		<el-config-provider :locale="zhCn">
			<el-table :row-class-name="rowClassName" ref="multipleTableRef" :data="resourceList" highlight-current-row
				style="width: 100%; margin-top: 2vh; margin-bottom: 2vh" @selection-change="handleSelectionChange">
				<el-table-column type="selection" />
				<!-- 表头 -->
				<el-table-column prop="fileName" label="文件名称" />
				<el-table-column prop="fileType" label="资源类型" />
				<el-table-column prop="comment" label="备注" />
				<el-table-column fixed="right" label="内容">
					<template #default="scope">
						<el-button link type="primary" @click="enterResourceButton(scope.row)">
							<template v-if="getIconName(scope.row) === 'video'">
								<el-icon>
									<VideoPlay />
								</el-icon>
							</template>
							<template v-else-if="getIconName(scope.row) === 'pdf'">
								<el-icon>
									<DocumentAdd />
								</el-icon>
							</template>
							<template v-else>
								<!-- 默认图标 -->
								<el-icon>
									<Document />
								</el-icon>
							</template>
						</el-button>
					</template>
				</el-table-column>
				<!-- 修改 -->
				<el-table-column fixed="right" label="操作">
					<template #default="scope">
						<el-button @click="modifyClass(scope.row)">修改备注</el-button>
						<el-button type="danger" @click="removeClass(scope.row)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 页面分页功能 -->
			<el-pagination :page-size="limit" :total="total" v-model:current-page="page" @click="fetchResourceList" />
		</el-config-provider>

		<!-- 上传文件对话框 -->
		<el-dialog title="上传资料" v-model="createDialogVisible" width="500px" @close="handleClose">
			<el-upload ref="uploadRef" :file-list="fileList" :auto-upload="false" :http-request="handleFileUpload"
				:on-change="onFileChange">
				<el-button>选择文件</el-button>
			</el-upload>
			<div v-if="uploadProgress > 0">
				<p>上传进度：{{ uploadProgress }}%</p>
				<el-progress :percentage="uploadProgress"></el-progress>
			</div>
			<div class="dialog-actions">
				<el-button @click="handleClose">取消</el-button>
				<el-button type="primary" @click="uploadFile" :disabled="!file">上传</el-button>
			</div>
		</el-dialog>
		<!-- 删除资源 -->
		<el-dialog title="确认删除选中资源" v-model="removeBatchDialogVisible" width="400px" :show-close="false">
			<span class="dialog-footer">
				<el-button @click="removeBatchDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="batchRemove">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="确认删除" v-model="removeDialogVisible" width="400px" :show-close="false">
			<el-form class="dialog-information">
				<p class="dialog-information-text">确认删除该资源？</p>
			</el-form>
			<span class="dialog-footer">
				<el-button @click="removeDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitRemove">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 编辑资源 -->
		<el-dialog title="编辑信息" v-model="modifyDialogVisible" width="400px" :show-close="false">
			<el-form :model="modifyFormData">
				<el-form-item label="备注" prop="comment">
					<el-input v-model="modifyFormData.comment" placeholder="请输入备注" />
				</el-form-item>
			</el-form>
			<span class="dialog-footer">
				<el-button @click="modifyDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="submitModifyForm">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { defineComponent, ref, } from "vue";
import zhCn from "element-plus/dist/locale/zh-cn.mjs";
import "@/styles/Common.css";

export default defineComponent({
	data() {
		return {
			fileList: [], // 选中文件列表
			file: null, // 当前选中的文件
			uploadProgress: 0, // 上传进度
			chunks: [], // 存储文件分块
			fileExtension: '',
			courseId: null,
			courseName: null,

			matterFrom: {
				fileType: "",
			},
			mattersFrom: {
				resourceId: "",
			},
			placeholder: {
				namePlaceholder: "请输入课程名",
			},
			selectRemoveId: "",
			removeBatchDialogVisible: false,
			removeDialogVisible: false,
			createDialogVisible: false,
			modifyDialogVisible: false,
			resetVisible: false,
			createFormData: {
				courseName: "",
				createDate: "",
				comment: "",
			},
			modifyFormData: {
				resourceId: "",
				comment: "",
			},

			// 获取资源列表
			filter: {
				fileType: "",
			},
			resourceList: [],
			page: 1,
			limit: 9,
			total: 0,
			interval: null,
			multipleSelection: [],
			batchRemoveDisabled: true,
			zhCn,
		};
	},
	// 刷新页面
	async mounted() {
		this.courseId = this.$route.params.courseId;
		this.courseName = this.$route.params.courseName;
		this.fetchResourceList();
		this.interval = setInterval(() => {
			this.fetchResourceList();
		}, 5000);
	},
	unmounted() {
		clearInterval(this.interval);
	},
	setup() {
		const multipleTableRef = ref(null);
		const currentId = ref(null);

		const getIconName = (row) => {
			const fileType = row.fileType;
			if (fileType === "mp4") {
				return "video";
			} else if (fileType === "pdf") {
				return "pdf";
			} else {
				return "other";
			}
		};

		return {
			multipleTableRef,
			currentId,
			getIconName,
		};
	},
	methods: {
		// 表格背景
		rowClassName({ rowIndex }) {
			return rowIndex % 2 === 0 ? "even-row" : "odd-row";
		},

		//上传文件
		// 关闭上传对话框
		handleClose() {
			this.createDialogVisible = false;
			this.file = null;
			this.fileList = [];
			this.uploadProgress = 0;
		},

		// 选择文件处理
		onFileChange(newFile) {
			this.file = newFile.raw;
		},

		// 上传文件
		async handleFileUpload({ file: rawFile }) {
			const chunkSize = 5 * 1024 * 1024; // 每块大小 5MB
			const totalChunks = Math.ceil(rawFile.size / chunkSize);
			const fileName = rawFile.name;
			const maxRetries = 3; // 最大重试次数

			for (let i = 0; i < totalChunks; i++) {
				const start = i * chunkSize;
				const end = Math.min(rawFile.size, start + chunkSize);
				const fileChunk = rawFile.slice(start, end);

				const formData = new FormData();
				formData.append("fileName", fileName);
				formData.append("id", this.courseId);
				formData.append("fileChunk", fileChunk);
				formData.append("index", i);

				let retries = 0;
				while (retries < maxRetries) {
					try {
						// 尝试上传文件块
						await this.$axios.post("/api/resource/upload", formData);
						this.uploadProgress = Math.round(((i + 1) / totalChunks) * 100);
						break; // 成功后跳出重试循环
					} catch (error) {
						retries++;
						console.error(`文件块 ${i} 上传失败，重试次数：${retries}`, error);
						if (retries >= maxRetries) {
							// 超过最大重试次数后，抛出错误并终止上传
							this.uploadProgress = 0;
							throw new Error(`文件块 ${i} 上传失败，已达到最大重试次数`);
						}
					}
				}
			}

			try {
				// 合并文件
				await this.$axios.post("/api/resource/upload/merge", {
					fileName,
					id: this.courseId,
					type: 0,
				});

				// 上传完成后刷新 PDF
				this.fetchResourceList();
				this.handleClose();
			} catch (error) {
				console.error("文件合并失败", error);
				throw new Error("文件合并失败，请重试");
			}
		},


		// 提交上传
		uploadFile() {
			if (this.file) {
				this.$refs.uploadRef.submit();
			}
		},

		//获取资源表单
		async fetchResourceList() {
			try {
				const response = await this.$axios.post("/api/resource/list", {
					courseId: this.courseId,
					page: this.page,
					limit: this.limit,
					fileType: this.filter.fileType
				});

				this.resourceList = response.data.resourceList; // 根据你的数据结构调整
				this.total = response.data.total;
			} catch (error) {
				console.error("An error occurred while fetching the dev list:", error);
			}
		},

		async enterResourceButton(row) {
			this.mattersFrom.resourceId = row.resourceId;
			this.matterFrom.fileType = row.fileType;
			if (this.matterFrom.fileType === "mp4") {
				await this.getvideo();
			} else {
				await this.getfile();
			}
		},
		async getvideo() {
			try {
				const response = await this.$axios.post("/api/resource/down", {
					resourceId: this.mattersFrom.resourceId
				});
				const fileUrl = response.data.fileUrl;
				if (fileUrl) {
					this.$router.push({
						name: 'classvideo',
						params: { fileUrl: fileUrl },
					});
				} else {
					console.error("fileUrl is missing from the response");
				}
			} catch (error) {
				console.error("获取视频时出错：", error);
			}
		},

		async getfile() {
			try {
				const response = await this.$axios.post("/api/resource/down", {
					resourceId: this.mattersFrom.resourceId
				});
				const fileUrl = response.data.fileUrl;
				if (fileUrl) {
					// 使用 params 或 query，这取决于你的路由配置
					await this.downloadFile(fileUrl);
				} else {
					console.error("fileUrl is missing from the response");
				}
			} catch (error) {
				// 处理可能发生的错误
				console.error("下载PPT时出错：", error);
			}
		},

		async downloadFile(fileUrl) {
			try {
				const windowObjectReference = window.open(
					`${this.$baseFileUrl}${fileUrl}`,
					"_blank",
					"noopener,noreferrer"
				);
				if (!windowObjectReference) {
					throw new Error("无法打开新窗口");
				}
			} catch (error) {
				// 处理可能发生的错误
				console.error("打开文件时出错：", error);
			}
		},
		// 编辑课程
		async modifyClass(row) {
			let item = this.resourceList.find(
				(item) => item.resourceId === row.resourceId
			);

			this.placeholder = {
				namePlaceholder: item.resourceName,
			};

			this.modifyDialogVisible = true;
			this.currentId = row.resourceId;
		},
		async submitModifyForm() {
			try {
				const postData = {
					resourceId: this.currentId,
					comment: this.modifyFormData.comment,
				};
				const response = await this.$axios.post(
					"/api/resource/update",
					postData
				);
				this.modifyFormData = {
					// 重置表单数据
					resourceId: "",
					comment: "",
				};

				console.log(response);
				this.modifyDialogVisible = false;
				this.placeholder = {
					namePlaceholder: "请输入资源名",
				};
				this.fetchResourceList();
			} catch (error) {
				console.error("Error creating user:", error);
				// 这里你可以添加其他错误处理逻辑，比如显示一个错误消息给用户
			}
		},
		// 删除用户
		async submitRemove() {
			try {
				const removeId = {
					resourceIds: [this.selectRemoveId],
				};

				const response = await this.$axios.post(
					"/api/resource/delete",
					removeId
				);
				console.log("User removed:", response.data);

				console.log(response);
				this.removeDialogVisible = false;
				this.placeholder = {
					namePlaceholder: "请输入课程名",
				};
				this.fetchResourceList();
			} catch (error) {
				console.error("Error removing user:", error);
				// 这里你可以添加其他错误处理逻辑，比如显示一个错误消息给用户
			}
		},
		// 移除用户
		async removeClass(row) {
			let item = this.resourceList.find(
				(item) => item.resourceId === row.resourceId
			);
			this.placeholder = {
				namePlaceholder: item.resourceName,
			};
			this.selectRemoveId = row.resourceId;
			this.removeDialogVisible = true;
		},
		async batchRemoveConfirm() {
			this.removeBatchDialogVisible = true;
		},
		async batchRemove() {
			const list = this.multipleSelection.map((item) => item.resourceId);
			try {
				const removeId = {
					resourceIds: list,
				};

				const response = await this.$axios.post(
					"/api/resource/delete",
					removeId
				);
				console.log("User removed:", response.data);
				this.removeBatchDialogVisible = false;
				this.fetchResourceList();
			} catch (error) {
				console.error("Error removing user:", error);
			}
		},
		handleSelectionChange(val) {
			this.multipleSelection = val;
			this.batchRemoveDisabled =
				this.multipleSelection.length == 0 ? true : false;
			if (this.multipleSelection.length != 0) {
				clearInterval(this.interval);
			} else {
				this.interval = setInterval(() => {
					this.fetchResourceList();
				}, 5000);
			}
			console.log(val);
		},
	},
});
</script>

<style scoped>
:deep .even-row {
	background-color: #f0f0f0;
	/* 设置偶数行的背景色 */
}

:deep .odd-row {
	background-color: #ffffff;
	/* 设置奇数行的背景色 */
}

.el-button {
	height: 100%;
	margin-right: 6px;
}

.el-pagination {
	margin-top: 1vh;
	position: absolute;
	bottom: 1vh;
}

.dialog-information {
	margin-bottom: 30px;
	border: 1px solid #ccc;
	border-radius: 5px;
}

.dialog-information-text {
	margin: 10px;
	font-size: 15px;
}

:deep .el-dialog__header {
	margin-right: 0px;
}

:deep .el-dialog__body {
	padding-top: 16px;
}

/* 对话框按钮操作区域 */
.dialog-actions {
	display: flex;
	justify-content: flex-end;
	margin-top: 20px;
}


.left-buttons {
	display: flex;
	/* 按钮之间的间距 */
}

.course-name {
	flex-grow: 1;
	/* 使中间区域填满剩余空间 */
	display: flex;
	/* 使 .course-name 成为一个 flex 容器 */
	justify-content: center;
	/* 水平居中 */
	align-items: center;
	/* 垂直居中 */
	text-align: center;
	/* 保证文本水平居中 */
}

.search {
	position: relative;
}
</style>
